import styled from "styled-components";
import { flexEndCenter } from "../style/mixins";
import { theme } from "../theme";
import { memberLogout } from "../api/member";

export default function Header() {
  const onClickLogout = () => {
    memberLogout();
  };
  
  return (
    <HeaderLayout>
      <LogoutButton type="button" onClick={() => onClickLogout()}>로그아웃</LogoutButton>
    </HeaderLayout>
  );
}

const HeaderLayout = styled.header`
  background-color: #fff;
  height: 4.25rem;
  padding-right: 2rem;
  border-bottom: 1px solid #D9DEE4;
  ${flexEndCenter};
`;

const LogoutButton = styled.button`
  color: #5A738E;
  font-size: 0.875rem;
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: color 0.1s;
  
  &:hover {
    color: ${theme.color.primary};
  }
`;